import Alert from './modules/Alert.js';
import Navigation from './modules/Navigation.js';
import Misc from './modules/Misc.js';
import MobileNavigation from './modules/MobileNavigation.js';
import Footer from './modules/Footer.js';
import Calendar from './modules/Calendar.js';

document.addEventListener('DOMContentLoaded', function() {
  Navigation();
  MobileNavigation();
  Footer();
  Alert();
  Misc();
  Calendar();

  // back to top link
  document.getElementById('backToTop').addEventListener('click', function(event) {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
  });

  // close gtranslate dropdown when language is selected
  var gTranslateDropdown = document.querySelector('.gt_option'); // GTranslate dropdown class

  if (gTranslateDropdown) {
    gTranslateDropdown.addEventListener('click', function() {
      setTimeout(function() {
        jQuery('#gtranslate-widget').fadeOut(390); // close box
      });
    });
  }
});
